import { render, staticRenderFns } from "./BackLink.vue?vue&type=template&id=aaf05aa2&scoped=true&"
import script from "./BackLink.vue?vue&type=script&lang=ts&"
export * from "./BackLink.vue?vue&type=script&lang=ts&"
import style0 from "./BackLink.vue?vue&type=style&index=0&id=aaf05aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf05aa2",
  null
  
)

export default component.exports